import gql from "graphql-tag";

export default gql`
  query TotalYearlyAmericanIssuerCompensation($tickerSymbol: TickerSymbol!) {
    totalYearlyAmericanIssuerCompensation(tickerSymbol: $tickerSymbol) {
      fiscalYear
      totalExecutiveCompensation
      totalBoardOfDirectorsCompensation
      totalCompensation
      revenue
      percentageOfRevenue

      ... on AmericanCompanyTotalCompensationByYear {
        netIncome
        percentOfNetIncome
      }

      ... on AmericanREITTotalCompensationByYear {
        fundsFromOperations
        percentOfFundsFromOperations
      }
    }
  }
`;
